import { toPng } from 'html-to-image'
import { Options } from 'html-to-image/src/types'
import { Ref } from 'vue'

export const downloadCSV = (data: string, filename?: Ref<string>) => {
  const defaultFileName = filename?.value || 'download'

  const link = document.createElement('a')
  link.download = `${defaultFileName}.csv`
  link.href = `data:text/csv;charset=utf-8,${encodeURI(data)}`
  link.click()
}

export const downloadPng = (target: Ref<HTMLElement>, filename?: Ref<string>, options?: Partial<Options & {
  excludeClassName: string
}>) => {
  const defaultFileName = filename?.value || 'download'

  toPng(target.value, {
    backgroundColor: options?.backgroundColor ?? undefined,
    width: options?.width ?? undefined,
    height: options?.height ?? undefined,
    filter: (node: HTMLElement) => {
      if (!options?.excludeClassName) {
        return true
      }
      return node.classList ? !node.classList.contains(options.excludeClassName) : true
    },
  }).then((dataUrl) => {
    const link = document.createElement('a')
    link.download = `${defaultFileName}.png`
    link.href = dataUrl
    link.click()
  })
}